import FindingsList from './FindingsList';

export default FindingsList;
